import * as React from 'react'
import getConfig from 'next/config'
import NextRouter from 'next/router'

import { CmsComponentSlot, getAlgoliaConfigFromBloomreach } from '@grandvisionhq/bloomreach'
import { MediaQuery } from '@grandvisionhq/common'
import {
  AlgoliaConfigProvider,
  AlgoliaConfigProviderProps,
  fetchAlgoliaConfig,
} from '@grandvisionhq/search'
import { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'

import { withCms, withLayout } from '../../cms'
import { createAlgoliaConfig } from '../../util/algolia'

const { publicRuntimeConfig } = getConfig()
const defaultLocale = publicRuntimeConfig?.defaultLocale ?? 'en-GB'

type InitialProps = {
  algoliaConfig: AlgoliaConfigProviderProps
}

type Props = InitialProps

const ContainerPage: NextPage<Props, InitialProps> = ({ algoliaConfig }) => (
  <AlgoliaConfigProvider {...algoliaConfig} NextRouter={NextRouter}>
    <CmsComponentSlot path="main" />
  </AlgoliaConfigProvider>
)

ContainerPage.getInitialProps = async ({ req, res, asPath = '' }) => {
  const pageModel = res?.locals?.pageModel
  const breakpoint = req?.mediaQueryBreakpoint as MediaQuery.BreakpointName
  const algoliaConfig = await fetchAlgoliaConfig({
    ...createAlgoliaConfig(asPath, pageModel, breakpoint),
    ...getAlgoliaConfigFromBloomreach(pageModel),
    locale: req?.locale?.toString() || defaultLocale,
  })

  return { algoliaConfig }
}

export default compose(withCms(), withLayout())(ContainerPage)
